// Library imports
import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer, Zoom } from "react-toastify";

// Internal imports
import * as config from "./config";
import Loading from "./component/loading";
import Main from "./page/main";
import Login from "./component/login";

// Design imports - Toast notifications
import "react-toastify/dist/ReactToastify.css";

// Lazy-loaded page components
const Legal = lazy(() => import("./page/legal"));
const Register = lazy(() => import("./page/register"));

// Lazy-loaded component pages
const RegisterDetail = lazy(() => import("./component/register_detail"));
const RegisterQr = lazy(() => import("./component/register_qr"));
const LoginSingpassCallback = lazy(() => import("./component/login_singpass_callback"));

export default function App() {
    /* Variables */

    // Routes
    // Set up all the app routes
    const m_router = createBrowserRouter(
        [
            {
                // Home route - main container is Main.jsx
                path: "/",
                element: <Main />,
                children: [
                    {
                        index: true,
                        element: <Login />, // CHANGED: No Suspense wrapper
                    },
                ],
            },
            {
                // Register route - main container is Register.jsx
                path: config.frontend.route.register.root,
                element: (
                    <Suspense fallback={<Loading message="Loading..." />}>
                        <Register />
                    </Suspense>
                ),
                children: [
                    {
                        path: config.frontend.route.register.detail,
                        element: (
                            <Suspense fallback={<Loading message="Loading..." />}>
                                <RegisterDetail />
                            </Suspense>
                        ),
                    },
                    {
                        path: config.frontend.route.register.qr,
                        element: (
                            <Suspense fallback={<Loading message="Loading..." />}>
                                <RegisterQr />
                            </Suspense>
                        ),
                    },
                ],
            },
            {
                // Legal route - standalone legal page with tabs
                path: config.frontend.route.legal.root,
                element: (
                    <Suspense fallback={<Loading message="Loading..." />}>
                        <Legal />
                    </Suspense>
                ),
            },
            {
                // Singpass callback route - authentication return endpoint
                path: config.frontend.route.singpass.callback,
                element: <Main />,
                children: [
                    {
                        index: true,
                        element: (
                            <Suspense fallback={<Loading message="Loading..." />}>
                                <LoginSingpassCallback />
                            </Suspense>
                        ),
                    },
                ],
            },
        ],
        {
            basename: config.frontend.route.root,
        }
    );

    /* Functions */
    return (
        <>
            {/* Toast notification system */}
            <ToastContainer
                autoClose={5000}
                closeOnClick={false}
                draggable={false}
                pauseOnFocusLoss={false}
                pauseOnHover={false}
                position="top-center"
                transition={Zoom}
            />

            {/* Render the full routing system */}
            <RouterProvider router={m_router} />
        </>
    );
}
